// Small pill showing "who did this" — used on the Orders list & Order Detail.
// Renders a coloured dot + the person's name. Falls back gracefully if the
// order pre-dates the created_by tracking.
export default function UserBadge({ user, label, size = "sm", testid }) {
  if (!user || !user.email) {
    return <span className="text-ink-mute text-xs font-figtree">—</span>;
  }
  const dot = size === "lg" ? "h-3 w-3" : "h-2.5 w-2.5";
  const text = size === "lg" ? "text-sm" : "text-xs";
  return (
    <span
      data-testid={testid}
      className={`inline-flex items-center gap-1.5 ${text} font-figtree`}
      title={user.email}
    >
      <span
        className={`${dot} rounded-full flex-shrink-0 ring-1 ring-white`}
        style={{ backgroundColor: user.color || "#5C6B61" }}
      />
      {label && <span className="text-ink-soft">{label}</span>}
      <span className="font-medium text-ink">{user.name || user.email}</span>
    </span>
  );
}
